import { store } from "@/blyn/legacy/state/store";
import { getSessionUserSnapshot } from "@/lib/auth";

export type BlynCurrentUser = {
  tenantId?: string | number;
  account_id?: string | number;
  accountId?: string | number;
  id?: string | number;
  userID?: string | number;
  userId?: string | number;
};

export function getCurrentUser(): BlynCurrentUser | null {
  return (store.get("currentUser") as BlynCurrentUser | null) ?? null;
}

/**
 * Host apps pass account_id; older mocks may still use tenantId.
 * The session snapshot is checked first since it's set synchronously on
 * every SessionProvider render, ahead of the store update in layout.tsx's
 * effect (which lags behind on first mount — see getSessionUserSnapshot).
 */
export function getTenantId(user?: BlynCurrentUser | null): string {
  const session = getSessionUserSnapshot();
  const u = user === undefined ? getCurrentUser() : user;
  const raw = session?.account_id ?? session?.accountId ?? session?.tenantId ?? u?.account_id ?? u?.accountId ?? u?.tenantId;
  if (raw != null && String(raw).length > 0) return String(raw);
  return "t_acme";
}

/** Host apps pass userID; older mocks may still use id. */
export function getUserId(user?: BlynCurrentUser | null): string {
  const session = getSessionUserSnapshot();
  const u = user === undefined ? getCurrentUser() : user;
  const raw = session?.userID ?? session?.userId ?? session?.id ?? u?.userID ?? u?.userId ?? u?.id;
  if (raw != null && String(raw).length > 0) return String(raw);
  return "u_jdoe";
}
